import { useAppSelector } from '@app/store';
import { PermissionsList } from '@appTypes/user.type';
export function usePermissionCheck(permissionKey?: PermissionsList): boolean {
  const userPermissions = useAppSelector((state) => state.userState.user?.permissions);
  if (!permissionKey) return false;
  if (!userPermissions) return false;
  return userPermissions?.includes(permissionKey);
}
